import instance from '~/services/hot-api/instance';
import {TListResponse} from '~/services/types';

import {
  AttemptBindPhoneResult,
  ConnectedProfile,
  ConnectedProfilesResponse,
  PhoneNumbersResponse,
  PostReplyResponse,
  ProfileResponse,
  Question,
  Review,
} from './types';

interface FetchProfilesParams {
  limit: number;
  offset: number;
  phoneNumbers: string[];
}

// Запрашиваем привязаныые профили
export const fetchConnectedProfiles = (params?: Partial<FetchProfilesParams>) =>
  instance.get<ConnectedProfilesResponse>('/frontend/api/v1/connected-profiles', {
    params,
  });

// Запрашиваем привязаныые номера телеофонов
export const fetchPhoneNumbers = () =>
  instance.get<PhoneNumbersResponse>('/frontend/api/v1/phone-numbers');

// Создаем сессию на привзяку номера телефона
export const requestBindConnectedPhone = (phoneNumber: string) =>
  instance.post<AttemptBindPhoneResult>(
    '/frontend/api/v1/connected-profiles/request-bind-by-phone',
    {
      phoneNumber,
    }
  );

// Метод подтверждения номера телефона по коду из смс
export const verifyConnectedPhone = (sessionId: string, confirmationCode: string) =>
  instance.post<ProfileResponse>('/frontend/api/v1/connected-profiles/bind-by-phone', {
    sessionId,
    confirmationCode,
  });

// Удаляем номер телефона из привязанных. Вмсесте с ним удалятся и привязанные профили
export const removePhone = (phoneNumber: string) =>
  instance.post<ProfileResponse>('/frontend/api/v1/connected-profiles/unbind-by-phone', {
    phoneNumber,
  });

interface FetchQuestionsParams {
  modelId: string;
  limit?: number;
  offset?: number;
}

export const fetchQuestionsByModelId = ({modelId, ...params}: FetchQuestionsParams) =>
  instance.get<TListResponse<Question>>(
    `/frontend/api/v1/connected-profiles/${modelId}/questions`,
    {
      params,
    }
  );

interface FetchReviewsParams {
  modelId: string;
  limit?: number;
  offset?: number;
}

export const fetchReviewsByModelId = ({modelId, ...params}: FetchReviewsParams) =>
  instance.get<TListResponse<Review>>(
    `/frontend/api/v1/connected-profiles/${encodeURIComponent(modelId)}/reviews`,
    {
      params,
    }
  );

interface PostReplyParams {
  modelId: string;
  replyId: string;
  comment: string;
}

interface PostQuestionReply extends PostReplyParams {
  questionId: string;
}

export const postQuestionReply = ({modelId, replyId, questionId, comment}: PostQuestionReply) =>
  instance.post<PostReplyResponse>(
    `/frontend/api/v1/connected-profiles/${encodeURIComponent(modelId)}/questions/replies`,
    {
      questionId,
      replyId,
      comment,
    }
  );

interface PostReviewReply extends PostReplyParams {
  reviewId: string;
}

export const postReviewReply = ({modelId, reviewId, replyId, comment}: PostReviewReply) =>
  instance.post<PostReplyResponse>(
    `/frontend/api/v1/connected-profiles/${encodeURIComponent(modelId)}/reviews/replies`,
    {
      reviewId,
      replyId,
      comment,
    }
  );

interface FetchProfile {
  profileId: string;
  modelId: string;
}

export const fetchProfile = ({profileId, modelId}: FetchProfile) =>
  instance.get<ConnectedProfile>(
    `/frontend/api/v1/connected-profiles/${encodeURIComponent(profileId)}/${encodeURIComponent(
      modelId
    )}`
  );
